/**
 * @file The photo uploads reducer (acting as a photo file cache).
 */

import {
  PHOTO_UPLOAD_SUCCESS,
  PHOTO_UPLOAD_REMOVE,
} from '../actions/photo-upload';

export const initialState = {
  photos: [],
};

const photoUploadsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case PHOTO_UPLOAD_SUCCESS:
      return {
        ...state,
        photos:
          state.photos.length === 15
            ? [action.photo, ...state.photos.slice(0, -1)]
            : [action.photo, ...state.photos],
      };

    case PHOTO_UPLOAD_REMOVE:
      return {
        ...state,
        photos: state.photos.filter(({ id }) => id !== action.photoId),
      };

    default:
      return state;
  }
};

export default photoUploadsReducer;
